export default class GlobalUtils {
	public static isSet(value: unknown): boolean {
		if (typeof value === "number") return !isNaN(value);
		if (typeof value === "string") return value.trim() !== "";
		return value !== undefined && value !== null;
	}
}
